import React, {PureComponent} from 'react';

import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import { translate } from 'react-i18next';

import './styles/tracksearcher.css';

import {debounce, sample, isEqual} from 'lodash';

class TrackSearcher extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      search: '',
      placeholder: '...',
      result: null,
    }
    this.reset = this.reset.bind(this);
    this.onWordChange = this.onWordChange.bind(this);
    this.search = debounce(this.search, 200);
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('component.module.artist.misc.TrackSearcher', {returnObjects: true});
  }


  reset() {
    this.setState({ search: '' });
    setTimeout(() => this.props.onSearch(null), 200);
  }


  onWordChange(value) {
    if (value === '') return this.reset();

    this.setState({ search: value });
    this.search(value.toLowerCase());
  }

  search(value) {
    let result = this.props.tracks.filter(track => this.parseObject(track, value)).map(track => track._id);

    if (isEqual(result, this.state.result)) return;

    this.props.onSearch(result);
    this.setState({ result });
  }

  parseObject(obj, value) {
    if (!obj) return false;
    return Object.entries(obj).some(item => {
      if (item[0] === '_id') return false;

      if (item[0] === 'stores') {
        return Object.entries(item[1]).filter(store =>
          String(store[0]).toLowerCase().includes(value) && store[1] !== ''
        ).length !== 0
      }

      return (typeof item[1] === 'object') ?
        this.parseObject(item[1], value) : String(item[1]).toLowerCase().includes(value)
    })
  }


  render() {
    return (
      <div className="component-module-artist-misc-TrackSearcher-container">
        <Paper
          className="paper-container"
          onMouseEnter={() => [
            this.setState({placeholder: `${sample(this.texts.searchbar.placeholders)}...`})
          ]}
          onMouseLeave={() => [
            this.setState({placeholder: '...'})
          ]}
        >
          <div className="searchbar">
            <Icon style={{color: '#888'}}color='inherit'> search </Icon>
            <input
              type='string'
              placeholder={this.state.placeholder}
              value={this.state.search}
              onChange={(e) => this.onWordChange(e.target.value)}
              />
            {
              this.state.search !== '' &&
              <IconButton onClick={this.reset}>
                <Icon style={{color: '#888'}}color='inherit'> clear </Icon>
              </IconButton>
            }
          </div>
        </Paper>
      </div>
    )
  }
}
export default translate('translations')(TrackSearcher);



// WEBPACK FOOTER //
// ./src/components/modules/artist/misc/TrackSearcher.js